// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
    list-style: none;
    margin: 0;
    padding: 0;
 }
 
 li {
    line-height: 20px;
    position: relative;
    margin-bottom: 10px;
 }
 
 .section-break {
    height: 20px;
 }
 
 li.section {
    font-weight: bold;
    padding: 5px 5px 5px 20px;
 }
 
 a, .topic {
    color: #666;
    display: inline-block;
    line-height: 20px;
    margin-left: 45px;
    padding: 5px 5px 0;
    position: relative;
 }
 
 a:hover {
    color: #ffa726;
 }
 
 a.social-link:hover {
    color: #ffa726;
    cursor: pointer;
 }
 
 a.active {
    color: #ff8326;
    cursor: initial;
 }
 
 a.active:hover {
    text-decoration: none;
 }
 
 i, .mat-icon {
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    width: 20px;
    position: absolute;
    left: -20px;
    top: 0;
 }

 img {
    width: 22px;
    height: 22px;
    position: absolute;
    left: -22px;
    top: 4px;
 }`, "",{"version":3,"sources":["webpack://./src/app/account/profile/profile-menu/profile-menu.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;CACb;;CAEA;IACG,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;CACtB;;CAEA;IACG,YAAY;CACf;;CAEA;IACG,iBAAiB;IACjB,yBAAyB;CAC5B;;CAEA;IACG,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;CACrB;;CAEA;IACG,cAAc;CACjB;;CAEA;IACG,cAAc;IACd,eAAe;CAClB;;CAEA;IACG,cAAc;IACd,eAAe;CAClB;;CAEA;IACG,qBAAqB;CACxB;;CAEA;IACG,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;CACT;;CAEA;IACG,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,QAAQ;CACX","sourcesContent":["ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n }\n \n li {\n    line-height: 20px;\n    position: relative;\n    margin-bottom: 10px;\n }\n \n .section-break {\n    height: 20px;\n }\n \n li.section {\n    font-weight: bold;\n    padding: 5px 5px 5px 20px;\n }\n \n a, .topic {\n    color: #666;\n    display: inline-block;\n    line-height: 20px;\n    margin-left: 45px;\n    padding: 5px 5px 0;\n    position: relative;\n }\n \n a:hover {\n    color: #ffa726;\n }\n \n a.social-link:hover {\n    color: #ffa726;\n    cursor: pointer;\n }\n \n a.active {\n    color: #ff8326;\n    cursor: initial;\n }\n \n a.active:hover {\n    text-decoration: none;\n }\n \n i, .mat-icon {\n    font-size: 18px;\n    line-height: 20px;\n    text-align: center;\n    width: 20px;\n    position: absolute;\n    left: -20px;\n    top: 0;\n }\n\n img {\n    width: 22px;\n    height: 22px;\n    position: absolute;\n    left: -22px;\n    top: 4px;\n }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
